import { ForgotPasswordTranslation } from '../../types/forgotPassword.types';

export const forgotPassword: ForgotPasswordTranslation = {
  title: 'Recuperação de Senha',
  form: {
    emailPlaceholder: 'Informe seu e-mail',
    emailLabel: 'E-MAIL',
    submit: 'ENVIAR',
  },
  successMessage:
    'Se o e-mail informado estiver cadastrado, você receberá uma nova senha em breve. Utilize-a para acessar o sistema.',
  backToLogin: 'Voltar ao login',
};

export default forgotPassword;
